import React from 'react';
import { createPortal } from 'react-dom';
import favoriteHeart from '../../assets/favorites_icon__red_heart__right_red.png';

interface ContactStartupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddToFavorites: () => Promise<void>;
  isLoading?: boolean;
}

const ContactStartupModal: React.FC<ContactStartupModalProps> = ({
  isOpen,
  onClose,
  onAddToFavorites,
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const handleAddClick = async () => {
    await onAddToFavorites();
    onClose();
  };

  return createPortal(
    <div
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-[100000] p-4"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="contact-modal-title"
    >
      <div
        className="bg-dark-900 border border-gray-700 rounded-lg shadow-xl max-w-xs w-full p-5"
        style={{ fontFamily: 'Rubik, sans-serif' }}
        onClick={e => e.stopPropagation()}
      >
        <p id="contact-modal-title" className="text-gray-300 text-base mb-4 text-center">
          To unlock contact info
        </p>
        <button
          type="button"
          onClick={handleAddClick}
          disabled={isLoading}
          className={`w-full py-3 rounded-full font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-900 text-white focus:ring-gray-500 shadow-[0_4px_6px_-1px_rgba(0,0,0,0.3)] flex items-center justify-center gap-2 bg-[#303030] hover:bg-[#363636] ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {isLoading ? (
            <>
              <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              <span>Loading...</span>
            </>
          ) : (
            <>
              <img src={favoriteHeart} alt="" className="h-5 w-5 object-contain" />
              Follow
            </>
          )}
        </button>
      </div>
    </div>,
    document.body
  );
};

export default ContactStartupModal;
